/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2015 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/

/*
	Only place in the app that should have a resize event handler. Add a callback to this module to receive resize events.

	Defers updates so callbacks are only called once per frame (using requestAnimationFrame), and will turn itself off after a number of frames following the last resize event.
*/
var iaw = iaw || { };

iaw.motor = {
	_running: false,
	_steps: 0,
	_cycle: 30, // number of frames to step for
	_throttleSwitch: false,
	_pistons: [],
	_stopped: false,

	start: function() {
		iaw.motor._running = false;
		this._stopped = false;
		iaw.motor._steps = 0;
		window.addEventListener('resize', iaw.motor.kick.bind(this), false);
	},

	stop: function() {
		this._stopped = true;
	},

	update: function() {
		if (this._stopped) return;
		if (iaw.motor._steps++ > iaw.motor._cycle) {
			// only run for a stride, then automatically shut off
			iaw.motor._running = false;
			return;
		}

		iaw.motor._throttleSwitch = !iaw.motor._throttleSwitch;
		if (iaw.motor._throttleSwitch) {
			// only run the pistons every other frame (30 fps throttle) because any more than that is overkill
			for (var i = 0; i < iaw.motor._pistons.length; i++) {
				var o = iaw.motor._pistons[i];
				o.func.call(o.scope || window, iaw.motor._cycle - iaw.motor._steps);
			}
		}

		window.requestAnimationFrame(iaw.motor.update);
	},

	// force an update cycle
	kick: function() {
		if (this._stopped) return;
		iaw.motor._steps = 0;
		if (iaw.motor._running) {
			return;
		}
		iaw.motor._running = true;
		iaw.motor.update();
	},

	// in order to be able to ID functions we have to hash them to generate unique-ish keys for us to find them with later
	// if we don't do this, we won't be able to remove callbacks that were bound and save us from binding callbacks multiple times all over the place
	add: function(cb, scope) {
		if (!cb) console.error('[iaw.motor.add] Pass in a valid function');
		var k = iaw.util.hashStr(cb.toString());
		var h = iaw.motor.has(k, scope);
		if (h === -1) {
			iaw.motor._pistons.push({
				func: cb,
				scope: scope,
				key: k
			});
		}
	},

	remove: function(cb) {
		var k = iaw.util.hashStr(cb.toString());
		var i = iaw.motor.has(k);
		if (i !== -1) {
			iaw.motor._pistons.splice(i, 1);
		}
	},

	// check if the handler already has iaw.motor particular callback
	has: function(k, scope) {
		var n = -1;
		var s = null;
		var i;
		for (i = 0; i < iaw.motor._pistons.length; i++) {
			n = iaw.motor._pistons[i].key;
			s = iaw.motor._pistons[i].scope;
			if (n === k && s === scope) {
				return i;
			}
		}
		return -1;
	}

	/*
		Nothing to do with motor but this has a RAF, so in order to keep track of all the RAF things, let's put them in this module.
		scrollTarget 		Element 	The element to scroll to
		[scrollDuration] 	Number 		How long the animation takes in milliseconds. Defaults to 500.
	*/
	/*scrollToTarget: function(scrollTarget, scrollContainer, scrollDuration) {

	}*/
};
